import { lazy } from 'react';

// project imports
import PrivateRoute from 'components/routing/PrivateRoute';
import Loadable from 'components/ui-component/Loadable';
import MainLayout from 'layout/MainLayout';

// dashboard routing
const Dashboard = Loadable(lazy(() => import('views/dashboard')));

// organisation routing
const Employees = Loadable(lazy(() => import('views/employees/Employees-page')));
const Employee = Loadable(lazy(() => import('views/employee/Employee-page')));
const WorkFlows = Loadable(lazy(() => import('views/workflow/WorkFlow-Pages/Main')));
const Products = Loadable(lazy(() => import('views/product/pages/Products')));
const NewProduct = Loadable(lazy(() => import('views/product/pages/CreateNewProduct/index')));
const Product = Loadable(lazy(() => import('views/product/pages/Product')));
const RuleGroups = Loadable(lazy(() => import('views/ruleGroups/ruleGroups-page/index')));
const PartnerRuleGroups = Loadable(lazy(() => import('views/ruleGroups/partnerRuleGroups-page/index')));
const Rules = Loadable(lazy(() => import('views/ruleGroups/Components/forms/rules/pages/Rules/index')));
const PartnerRules = Loadable(lazy(() => import('views/ruleGroups/Components/forms/rules/pages/PartnerRules/index')));
const CreateRule = Loadable(lazy(() => import('views/ruleGroups/Components/forms/rules/pages/CreateNewRule/index')));
const Rule = Loadable(lazy(() => import('views/ruleGroups/Components/forms/rules/pages/Rule/index')));
const PartnerRule = Loadable(lazy(() => import('views/ruleGroups/Components/forms/rules/pages/PartnerRule/index')));
const LoansStatus = Loadable(lazy(()=>import('views/loansStatus')))

// masters routing
const Departments = Loadable(lazy(() => import('views/masters/departments/Departments-page')));
const Roles = Loadable(lazy(() => import('views/masters/roles/Roles-page')));
const Branches = Loadable(lazy(() => import('views/masters/branches/Branches-page')));
const States = Loadable(lazy(() => import('views/masters/states/States-page')));
const Pincodes = Loadable(lazy(() => import('views/masters/pincodes/Pincodes-page')));
const BankDetails = Loadable(lazy(() => import('views/advanced/bankDetails/bankDetails-page')));
const AuditLogs = Loadable(lazy(() => import('views/auditLog/index')));
const CourseTypes = Loadable(lazy(() => import('views/masters/courseTypes/CourseTypes-page')));
const Groups = Loadable(lazy(() => import('views/masters/groups/Groups-page')));
const Partners = Loadable(lazy(() => import('views/masters/partners/Partners-page')));
const LoanTypes = Loadable(lazy(() => import('views/masters/loanTypes/loanTypes-page')));
const CommonMasterComponent = Loadable(lazy(() => import('views/masters/commonMaster/CommonMaster-Page')));
const AttributeGroups = Loadable(lazy(() => import('views/masters/attributeGroups/attributeGroups-page')));
const ComputedAttributes = Loadable(lazy(() => import('views/masters/computedAttributes/computedAttributes-page')));
const Attributes = Loadable(lazy(() => import('views/masters/attributes/attributes-page')));
const RuleCategories = Loadable(lazy(() => import('views/masters/ruleCategories/ruleCategories-page')));
const Deviation = Loadable(lazy(() => import('views/masters/deviation/index')));
const CustomerNotifications = Loadable(lazy(() => import('views/productFeatures/customerNotifications/index')));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
	path: '/',
	element: (
		<PrivateRoute>
			<MainLayout />
		</PrivateRoute>
	),
	children: [
		{
			path: '/',
			element: <Dashboard />,
		},
		{
			path: 'dashboard',
			element: <Dashboard />,
		},
		{
			path: 'employees',
			element: <Employees />,
			// element: <CommonMasterComponent name = 'Employees' path = 'employees' />
		},
		{
			path: 'employees/:employeeId',
			element: <Employee />,
		},
		{
			path: 'departments',
			element: <Departments />,
			// element: <CommonMasterComponent name = 'Departments' path = 'departments' />
		},
		{
			path: 'roles',
			element: <Roles />,
			// element: <CommonMasterComponent name = 'Roles' path = 'roles' />
		},
		{
			path: 'branches',
			element: <Branches />,
			// element: <CommonMasterComponent name = 'Branches' path = 'branches' />
		},
		{
			path: 'states',
			element: <States />,
			// element: <CommonMasterComponent name = 'States' path = 'states' />
		},
		{
			path: 'pincodes',
			element: <Pincodes />,
			// element: <CommonMasterComponent name = 'Pincodes' path = 'pincodes' />
		},
		{
			path: 'qualifications',
			// element: <Qualifications />
			element: <CommonMasterComponent name="Qualifications" path="qualifications" />,
		},
		{
			path: 'residenceTypes',
			// element: <ResidenceStatuses />
			element: <CommonMasterComponent name="Residence Status" path="residenceTypes" />,
		},
		{
			path: 'relationships',
			// element: <Relationships />
			element: <CommonMasterComponent name="Relationships" path="relationships" />,
		},
		{
			path: 'occupationTypes',
			// element: <OccupationTypes />
			element: <CommonMasterComponent name="Occupation Types" path="occupationTypes" />,
		},
		{
			path: 'bank-account-types',
			// element: <BankAccountTypes />
			element: <CommonMasterComponent name="Bank Account Types" path="bank-account-types" />,
		},
		{
			path: 'documentTypes',
			// element: <DocumentTypes />
			element: <CommonMasterComponent name="Document Types" path="documentTypes" />,
		},
		{
			path: 'customerNotifications',
			element: <CustomerNotifications />,
			// element: <CommonMasterComponent name="Occupation Types" path="occupationTypes" />,
		},
		{
			path: 'fees',
			// element: <Fees />
			element: <CommonMasterComponent name="Fees" path="fees" />,
		},
		{
			path: 'workflows',
			element: <WorkFlows />,
		},
		{
			path: 'products/create',
			element: <NewProduct />,
		},
		{
			path: 'products',
			element: <Products />,
		},
		{
			path: 'products/:productId',
			element: <Product />,
		},
		{
			path: 'templates',
			// element: <Templates />
			element: <CommonMasterComponent name="Templates" path="templates" />,
		},
		{
			path: 'languages',
			// element: <Languages />
			element: <CommonMasterComponent name="Languages" path="languages" />,
		},
		{
			path: 'property-types',
			// element: <PropertyTypes />
			element: <CommonMasterComponent name="Property Types" path="property-types" />,
		},
		{
			path: 'loanPurposes',
			// element: <LoanPurposes />
			element: <CommonMasterComponent name="Loan Purpose" path="loanPurposes" />,
		},
		{
			path: 'bank-details',
			element: <BankDetails />,
			// element: <CommonMasterComponent name = 'Bank Details' path = 'bank-details' />
		},
		{
			path: 'audit-logs',
			element: <AuditLogs />,
		},
		{
			path: 'rejection-reasons',
			// element: <RejectionReasons />
			element: <CommonMasterComponent name="Rejection Reasons" path="rejection-reasons" />,
		},
		{
			path: 'stageStatus',
			// element: <StageStatus />
			element: <CommonMasterComponent name="Loan Sub Status" path="stageStatus" />,
		},
		{
			path: 'ifsc',
			// element: <Ifsc />
			element: <CommonMasterComponent name="Ifsc" path="ifsc" />,
		},
		{
			path: 'admissionStatuses',
			// element: <AdmissionStatuses />
			element: <CommonMasterComponent name="Admission Status " path="admissionStatuses" />,
		},
		{
			path: 'apiStatuses',
			// element: <ApiStatuses />
			element: <CommonMasterComponent name="Api Status" path="apiStatuses" />,
		},
		{
			path: 'campaigns',
			// element: <Campaigns />
			element: <CommonMasterComponent name="Campaigns" path="campaigns" />,
		},
		{
			path: 'caseNoteTypes',
			// element: <CaseNoteTypes />
			element: <CommonMasterComponent name="Case Note Types" path="caseNoteTypes" />,
		},
		{
			path: 'bureauDecisions',
			// element: <BureauDecisions />
			element: <CommonMasterComponent name="Bureau Decisions" path="bureauDecisions" />,
		},
		{
			path: 'cibilDecisions',
			// element: <CibilDecisions />
			element: <CommonMasterComponent name="Cibil Decisions" path="cibilDecisions" />,
		},
		{
			path: 'coefficients',
			element: <CommonMasterComponent name="Coefficients" path="coefficients" />,
		},
		{
			path: 'institutionTypes',
			// element: <CollegeInstitutes />
			element: <CommonMasterComponent name="College Institutions" path="institutionTypes" />,
		},
		{
			path: 'advanceEMITypes',
			// element: <AdvanceEMITypes />
			element: <CommonMasterComponent name="Advance Emi Types" path="advanceEMITypes" />,
		},
		{
			path: 'credentials',
			// element: <Credentials />
			element: <CommonMasterComponent name="Credentials" path="credentials" />,
		},
		{
			path: 'templateCodes',
			// element: <TemplateCodes />
			element: <CommonMasterComponent name="Template codes" path="templateCodes" />,
		},
		{
			path: 'partnerCategorisations',
			// element: <PartnerCategorisations />
			element: <CommonMasterComponent name="Partner Categorisations" path="partnerCategorisations" />,
		},
		{
			path: 'ipConfigurations',
			// element: <IpConfigurations />
			element: <CommonMasterComponent name="Ip Configurations" path="ipConfigurations" />,
		},
		{
			path: 'indusValidationMessages',
			// element: <IndusValidationMessages />
			element: <CommonMasterComponent name="Indus Validation Messsages" path="indusValidationMessages" />,
		},
		{
			path: 'indusCityStates',
			// element: <IndusCityStates />
			element: <CommonMasterComponent name="Indus City States" path="indusCityStates" />,
		},
		{
			path: 'documentCategories',
			// element: <DocumentCategories />
			element: <CommonMasterComponent name="Document Categories" path="documentCategories" />,
		},
		{
			path: 'cpvFcuStatuses',
			// element: <CpvStatuses />
			element: <CommonMasterComponent name="CPV Status" path="cpvFcuStatuses" />,
		},
		{
			path: 'courseTypes',
			element: <CourseTypes />,
		},
		{
			path: 'cpvAgencies',
			element: <CommonMasterComponent name="CPV Agencies" path="cpvAgencies" />,

			// element: <CpvAgencies />
		},
		{
			path: 'declineReasons',
			element: <CommonMasterComponent name="Declined Reasons" path="declineReasons" />,
		},
		{
			path: 'disbursementModes',
			element: <CommonMasterComponent name="Disbursement Modes" path="disbursementModes" />,
		},
		{
			path: 'esignDeactivateReasons',
			element: <CommonMasterComponent name="E sign Deactivate Reasons" path="esign-deactivateReasons" />,
		},
		{
			path: 'fcuAgencies',
			element: <CommonMasterComponent name="FCU Agencies" path="fcuAgencies" />,
		},
		{
			path: 'fcuStatuses',
			element: <CommonMasterComponent name="FCU statuses" path="fcu-statuses" />,
		},
		{
			path: 'groups',
			element: <Groups name="Groups" path="groups" />,
		},
		{
			path: 'partners',
			element: <Partners name="Partners" path="partners" />,
		},
		{
			path: 'jobTypes',
			element: <CommonMasterComponent name="Job Types" path="job-types" />,
		},
		{
			path: 'businessTypes',
			element: <CommonMasterComponent name="Business Types" path="businessTypes" />,
		},
		{
			path: 'programmes',
			element: <CommonMasterComponent name="Programmes" path="programmes" />,
		},
		{
			path: 'loan-status',
			element: <CommonMasterComponent name="Loan Status" path="loan-status" />,
		},
		{
			path: 'loanTypes',
			element: <LoanTypes name="Loan Types" path="loanTypes" />,
		},
		{
			path: 'stamping-authority',
			element: <CommonMasterComponent name="Stamping Authority" path="stamping-authority" />,
		},
		{
			path: 'restrictedProfiles',
			element: <CommonMasterComponent name="Restricted Profile" path="restrictedProfiles" />,
		},
		{
			path: 'mandate-events',
			element: <CommonMasterComponent name="Mandate Events" path="mandate-events" />,
		},
		{
			path: 'mitigants',
			element: <CommonMasterComponent name="Mitigant" path="mitigants" />,
		},
		{
			path: 'caseHistoryActions',
			element: <CommonMasterComponent name="Case History Actions" path="caseHistoryActions" />,
		},
		{
			path: 'attributeGroups',
			element: <AttributeGroups name="Rule Attribute Groups" path="attributeGroups" />,
		},
		{
			path: 'attributes/:groupId',
			element: <Attributes name="Rule Attributes" path="attributes/:groupId" />,
		},
		{
			path: 'computedAttributes',
			element: <ComputedAttributes name="Computed Attributes" path="computedAttributes" />,
		},
		{
			path: 'ruleCategories',
			element: <RuleCategories name="Rule Categories" path="ruleCategories" />,
		},
		{
			path: 'ruleGroups',
			element: <RuleGroups name="Rule Groups" path="ruleGroups" />,
		},
		{
			path: 'ruleGroups/:groupId',
			element: <Rules />,
		},
		{
			path: 'partnerRuleGroups',
			element: <PartnerRuleGroups name="Partner Rule Groups" path="partnerRuleGroups" />,
		},
		{
			path: 'partnerRuleGroups/:groupId',
			element: <PartnerRules />,
		},
		{
			path: 'rules/:groupId/create',
			element: <CreateRule />,
		},
		{
			path: 'partnerRules/:groupId/create',
			element: <CreateRule />,
		},
		{
			path: 'rules/:ruleId',
			element: <Rule />,
		},
		{
			path: 'partnerRules/:ruleId',
			element: <PartnerRule />,
		},
		{
			path: 'deviation',
			element: <Deviation name="Deviation" path="deviation" />,
		},
		{
			path: 'globalSwitchConfigurations',
			element: <CommonMasterComponent name="Global Switch Configurations" path="globalSwitchConfigurations" />,
		},
		{
			path: '/domains',
			element: <CommonMasterComponent name="Domains" path="domains" />,
		},
		{
			path: '/lenders',
			element: <CommonMasterComponent name="Lenders" path="lenders" />,
		},
		{
			path: '/loansStatus',
			element: <LoansStatus />,
		},
	],
};
export default MainRoutes;
